import React from 'react';
import './AtlasContextMenu.css';
import { createPortal } from 'react-dom';
import { useCopiedDoc } from '../../../../hooks/useCopiedDoc';
import { pasteDocMenuLabel } from '../../../../utils/docClipboard';

const AtlasContextMenu = ({
  ctx,
  useDemo,
  selectedCount = 1,
  isUnfiled = false,
  onCreateRootFolder,
  onCreateChild,
  onCreateDoc,
  onPasteDoc,
  onRename,
  onBrowseFolder,
  onDelete,
  onClose,
}) => {
  const copied = useCopiedDoc();
  if (!ctx) return null;
  const isCanvas = !ctx.folderId;
  const canPaste = Boolean(copied?.docId);
  const pasteLabel = canPaste ? pasteDocMenuLabel(copied.title) : 'Paste doc here';
  return createPortal(
    <div
      className="atlas__ctx"
      style={{ left: ctx.x, top: ctx.y }}
      onClick={(e) => e.stopPropagation()}
    >
      {isCanvas && !useDemo && (
        <>
          <button type="button" onClick={() => onCreateRootFolder?.()}>
            New folder
          </button>
          <button type="button" onClick={() => onCreateDoc?.(null)}>
            New doc
          </button>
          <button
            type="button"
            disabled={!canPaste}
            onClick={() => canPaste && onPasteDoc?.(null)}
          >
            {pasteLabel}
          </button>
        </>
      )}

      {!isCanvas && !isUnfiled && !useDemo && (
        <>
          <button type="button" onClick={() => onRename?.(ctx.folderId)}>
            Rename
          </button>
          <button type="button" onClick={() => onCreateChild(ctx.folderId)}>
            New subfolder
          </button>
          <button type="button" onClick={() => onCreateDoc(ctx.folderId)}>
            New doc here
          </button>
          <button
            type="button"
            disabled={!canPaste}
            onClick={() => canPaste && onPasteDoc?.(ctx.folderId)}
          >
            {pasteLabel}
          </button>
        </>
      )}

      {!isCanvas && isUnfiled && !useDemo && (
        <>
          <button type="button" onClick={() => onCreateDoc(ctx.folderId)}>
            New doc here
          </button>
          <button
            type="button"
            disabled={!canPaste}
            onClick={() => canPaste && onPasteDoc?.(ctx.folderId)}
          >
            {pasteLabel}
          </button>
        </>
      )}

      {!isCanvas && onBrowseFolder && (
        <button
          type="button"
          onClick={() => {
            onBrowseFolder(isUnfiled ? null : ctx.folderId);
            onClose();
          }}
        >
          Open in Browse
        </button>
      )}

      {!isCanvas && !isUnfiled && !useDemo && onDelete && (
        <button
          type="button"
          className="atlas__ctx--danger"
          onClick={() => onDelete(ctx.folderId)}
        >
          {selectedCount > 1 ? `Delete ${selectedCount} folders` : 'Delete folder'}
        </button>
      )}
    </div>,
    document.body
  );
};

export default AtlasContextMenu;
